import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getShipmentsTotal,
    getShipmentsCanceled,
    getShipmentsFinalprice,
    getShipmentsShipmentcost,
    getShipmentsProvidersTop,
    getShipmentsClientsTop,
    getCreditsLatest,
    getCreditsUsersTop,
    getCharges,
    getChargesPending,
    getChargesUsersTop,
    getChargesRefundsUsersTop,
}

function getShipmentsTotal(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/total`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsCanceled(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/canceled`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsFinalprice(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/finalprice`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsShipmentcost(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/shipmentcost`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsProvidersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/providers/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsClientsTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/clients/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getCreditsLatest(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/credits/latest`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getCreditsUsersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/credits/users/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getCharges(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesPending(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges/pending`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesUsersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges/users/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesRefundsUsersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges/refunds/users/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
